import { createFileRoute } from '@tanstack/react-router'
import { SmartSearchDetail } from '@/features/smart-search/detail'

function RouteComponent() {
  const { searchId } = Route.useParams()
  return <SmartSearchDetail searchId={searchId} />
}

export const Route = createFileRoute('/_authenticated/company-jobs/smart-search/$searchId/')({
  component: RouteComponent,
})
